import { Box, Grid, Stack, Typography } from "@mui/material";
import { FormField } from "@/components/elements/FormField";
import { divider, black } from "@/theme/colors";
import { InnerBox } from "@/components/elements/InnerBox";
import { useFormContext } from "react-hook-form";
import { Select } from "@/components/elements/Select";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { InputDatePicker } from "@/components/elements/InputDatePicker";
import { Textarea } from "@/components/elements/Textarea";
import { FCC } from "@/types/common";
import { useGetUserListPersonInCharge } from "@/api/services/main/user";
import { dayjs } from "@/utils/dayjs";

type TalentFormInternalMemoProps = {};

export const TalentFormInternalMemo: FCC<TalentFormInternalMemoProps> = () => {
  const methods = useFormContext<TTalentForm>();
  const { control } = methods;
  const { userOptions } = useGetUserListPersonInCharge();

  return (
    <InnerBox mt={4} p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            社内メモ
          </Typography>
        </Box>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="internalMemo" noLabel>
              <Textarea placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="interviewDate">
              <InputDatePicker placeholder="1990/06/25" minDate={dayjs("1990-01-01")} />
            </FormField>
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="interviewerId">
              <Select options={userOptions} />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
